<div class="adx-lib-widget-add-wrapper">
    <p>{{ 'OICL_OPENBRIDGE.THRUSTER.WIDGET.ADD.DESCRIPTION' | translate }}</p>
</div>
